"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var Alert = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (store.alertText
        ? (react_1.default.createElement("div", { className: "estimateForm-Alert" }, store.alertText)) : null);
});
exports.default = Alert;
